import axios from "axios";
import router from "../../../router/router.js";
export default {
    async login(context, payload) {
        let apiURL = "https://publish.dkilo.com/api/login";
        const res = await axios.post(apiURL, {
            email: payload.email,
            password: payload.password,
        });
        router.push("/");
        localStorage.setItem("firstName", res.data.publisher.first_name);
        localStorage.setItem("token", res.data.access_token);
        localStorage.setItem('country_code', res.data.publisher.country_code);
        localStorage.setItem('tracker', res.data.publisher.tracker);
        context.commit("setToken", res.data.access_token);
        context.commit("updateCountryCode", res.data.publisher.country_code);
        context.commit("updateTrackerStatus", res.data.publisher.tracker);
        context.commit('updateFirstName');
        // alert(`Welcome ${localStorage.getItem("firstName")}`);
    },
    async signUp(context, payload) {
        let api = "https://publish.dkilo.com/api/register";
        const headers = {
            "Country-Code": payload.country_code
        };
        const response = await axios.post(api, {
            first_name: payload.first_name,
            last_name: payload.last_name,
            mobile: payload.mobileNumber,
            country_code: payload.country_code,
            email: payload.email,
            password: payload.password,
        }, { headers });
        // router.push("/");
    },
    async logout(context) {
        try {
            context.commit("toggleLoading");
            localStorage.clear();
            router.push("/login");
            context.dispatch("triggerToggleModal");
            context.commit("setToken", null);
            const res = await axios.get("https://publish.dkilo.com/api/logout", {
                headers: {
                    token: localStorage.getItem("token"),
                    "Country-Code": localStorage.getItem("country_code")
                },
            });

            context.commit("toggleLoading");
        } catch (error) {
            context.commit("toggleLoading");
        }
    },
    async me(context) {
        let tokeen = localStorage.getItem("token");
        const res = await axios.get("https://publish.dkilo.com/api/me?", {
            headers: { token: tokeen, "Country-Code": localStorage.getItem("country_code") },
        });
        // console.log('asxcasca');
        // console.log(context.state.country_code);
        context.state.new_publisher = res.data.publisher.new_publisher;
        context.state.profile_pic = res.data.profile_picture;
        context.state.country_code = res.data.publisher.country_code;
    },
};
